module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.userinfo.balance < 0 && _vm.userinfo.force_order == 0) ? _c('el-alert', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "title": "您的余额为负数，无法委托平台下单，请及时充值",
      "type": "warning",
      "show-icon": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('xcurd', {
    attrs: {
      "topBtns": _vm.topBtns,
      "dialogs": _vm.dialogs,
      "table": _vm.table
    },
    on: {
      "clickRowBtn": function($event) {},
      "clickMultiBtn": function($event) {},
      "clickTopBtn": function($event) {}
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-455f48cc!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/store/order_before.vue
// module id = 219
// module chunks = 2